/**
 * Created by danielr on 9/21/15.
 */
define(function (require) {
    'use strict';

    var LE = require("app");
    var Page = require("ui.components/page/Page");
    var CONST = require("const");
    var AppKeysGalleryView = require("manager-views/data-sources/integrations/app-keys/AppKeysGalleryView");

    var AppKeysGalleryController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AppKeysGalleryController = Marionette.Controller.extend({
            initialize: function(options) {
                this._initialize(options);
            },
            getView: function() {
                return this._getView();
            },
            show: function() {
                this._show();
            },

            _initialize: function (options) {
                LEManager.logger.info("initializing", "AppKeysGalleryController:initialize");
                this.channel = LEManager.media.channel("appKeysGallery");

                this._bindEvents();
            },

            _bindEvents: function () {
                //routing events
                this.listenTo(this.channel, "GalleryView:closeWindow", this._onCancel);
                this.listenTo(this.channel, "GalleryView:done", this._onDone);

                //controlling events
                this.listenTo(this.channel, "GalleryView:select", this._onSelect);
                this.listenTo(this.channel, "GalleryView:create", this._onCreate);
                this.listenTo(this.channel, "GalleryView:edit", this._onEdit);

            },

            _getView: function() {
                this._initPageView();
                return this.pageView;
            },

            _initPageView: function(page){
                LEManager.logger.debug("init page view and listen to its close", "AppKeysGalleryController:_initPageView");
                this.pageView = new Page({
                    moduleName: LEManager.moduleName,
                    context: LE.context,
                    header: {
                        title: LE.translator.translate("LEManager.manager.dataSources.appKey.title"),
                        description: LE.translator.translate("LEManager.manager.dataSources.appKey.description"),
                        knowledgePack: {
                            text: LE.translator.translate("LEFramework.global.captions.learnMore"),
                            eventId: "liveengage-mobile-sdk"
                        }
                    },
                    hasActionStrip: true
                });
                this.listenTo(this.pageView, "close", _.bind(this._onPageClose, this, this.pageView));
            },

            _onPageClose: function(closedPageView) {
                LEManager.logger.debug("Page component in app keys gallery is closed.", "AppKeysGalleryController:_onPageClose");

                if (closedPageView) {
                    this.stopListening(closedPageView);
                }

                if (this.pageView && closedPageView && closedPageView.cid === this.pageView.cid) {
                    this.pageView = null;
                    this.insideView = null;
                }
            },

            _show: function() {
                var appKeysCollection = LEManager.getModuleDataManager().getData(LEManager.getModuleDataManager().getEntities().APP_KEYS);
                var appKeysGalleryCollection = LEManager.getModuleDataManager().getData(LEManager.getModuleDataManager().getEntities().APP_KEYS_GALLERY);

                var previousRoute = LE.context.get("previousApplicationRoute.route");
                if (this.lastEditItemRoute && this.lastEditItemRoute === previousRoute){
                    //we came from galleryItem Edit do not touch the selection
                } else{
                    //if we come from bookmark or data sources integrations tab - reset selected Items
                    this.selectedItemId = appKeysCollection.size() > 0 ? appKeysCollection.at(0).id : -1;
                }

                this.insideView = new AppKeysGalleryView({
                    channel: this.channel,
                    selectedItemId: this.selectedItemId,
                    galleryCollection: appKeysGalleryCollection
                });

                this.pageView.setInsideView(this.insideView);
            },

            _onSelect: function(selectedItemId){
                this.selectedItemId = selectedItemId;
            },

            _onCreate: function() {
                this._routeToItemEdit(CONST.ROUTING.NEW_ITEM_ID);
            },

            _onEdit: function(itemId) {
                this._routeToItemEdit(itemId);
            },

            _routeToItemEdit: function(id) {
                var currentRoute = LE.context.get("navigationCurrent.route");
                this.lastEditItemRoute = currentRoute + "/" + id;
                LEManager.router.navigate(this.lastEditItemRoute);
            },

            _onCancel: function(){
                LEManager.router.navigateBack();
            },

            _onDone: function(){
                LEManager.router.navigateBack();
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return  AppKeysGalleryController;
});

